import { lazy } from "react";
import { Navigate } from "react-router-dom";

import AuthGuard from "./auth/AuthGuard";
import OnboardingGuard from "./auth/OnboardingGuard";
import { authRoles } from "./auth/authRoles";

import Loadable from "./components/Loadable";
import MatxLayout from "./components/MatxLayout/MatxLayout";

import materialRoutes from "app/views/material-kit/MaterialRoutes";

//AdminPortal Routes
import CoreRolesRoutes from "app/views/admin-portal/manage-roles/CoreRolesRoutes";
import MailConfigRoutes from "app/views/admin-portal/mail-config/MailConfigRoutes";
import MailServerConfigRoutes from "app/views/admin-portal/mail-server-config/MailServerConfigRoutes";
import MenuManagerRoutes from "app/views/admin-portal/menu-manager/MenuManagerRoutes";
import UserRolesRoutes from "app/views/admin-portal/user-roles/UserRolesRoutes";
import ManageUriRoutes from "app/views/admin-portal/manage-uri/ManageUriRoutes";
import AccessControlRoutes from "app/views/admin-portal/access-control/AccessControlRoutes";
import PasswordChange from "app/views/admin-portal/password-change/PasswordChange";
import AuthConfigRoutes from "app/views/admin-portal/auth-config/AuthConfigRoutes";
import OfficeLocationRoutes from "app/views/admin-portal/office-locations/OfficeLocationRoutes";
import OfficeLocationMappingRoutes from "app/views/admin-portal/office-location-mapping/OfficeLocationMappingRoutes";
import AccountRoutes from "app/views/admin-portal/manage-accounts/AccountRoutes";
import CrmRoutes from "app/views/admin-portal/crm/CrmRoutes";

//Assets Routes
import CreateServersRoutes from "app/views/asset-portal/manage-servers/ManageServersRoutes";
import CreateAssetRoutes from "app/views/asset-portal/manage-assets/ManageAssetsRoutes";
import HardDiskRoutes from "app/views/admin-portal/harddisk/HardDiskRoutes";
import OsRoutes from "app/views/admin-portal/os/OsRoutes";
import RamRoutes from "app/views/admin-portal/ram/RamRoutes";
import CategoryRoutes from "app/views/admin-portal/category/CategoryRoutes";
import ProcessorRoutes from "app/views/admin-portal/processor/ProcessorRoutes";
import GroupRoutes from "app/views/asset-portal/asset-groups/GroupRoutes";
import SubGroupRoutes from "app/views/asset-portal/sub-groups/SubGroupRoutes";
import UserProfileRoutes from "app/views/admin-portal/manage-users/UserProfileRoutes";
import ManageAssetsDetailsRoutes from "app/views/asset-portal/manage-master-assets/ManageAssetsDetailsRoutes";
import WarrentyCheckRoutes from "app/views/asset-portal/warrenty-check/WarrentyCheckRoutes";
import AuditRoutes from "app/views/asset-portal/audits/AuditRoutes";
import VMRequestRoutes from "app/views/asset-portal/vm-requests/VMRequestRoutes";
import DynamicTableRoutes from "app/views/asset-portal/dynamic-table/DynamicTableRoutes";
import AssetTypeRoutes from "app/views/admin-portal/asset-type/AssetTypeRoutes";

//Employee Management
import OnboardingRoutes from "app/views/healthcare-portal/onboarding/OnboardingRoutes";
import TimesheetRoutes from "app/views/employee-portal/timesheet/TimesheetRoutes";
import EmployeeAttendanceRoutes from "app/views/employee-portal/employee-attendance/EmployeeAttendanceRoutes";
import LeaveTypeRoutes from "app/views/employee-portal/leave-system/leave-types/LeaveTypeRoutes";
import LeaveApplicationRoutes from "app/views/employee-portal/leave-system/leave-application/LeaveApplicationRoutes";
import PublicHolidayRoutes from "app/views/employee-portal/leave-system/public-holidays/PublicHolidayRoutes";
import EmployeeAttendanceReportRoutes from "app/views/employee-portal/employee-attendance-report/EmployeeAttendanceReportRoutes";
import DepartmentRoutes from "app/views/employee-portal/department/DepartmentRoutes";

//ITCMS
import ChangeRequestRoutes from "app/views/itcms/change-request/ChangeRequestRoutes";

//Asset Disposal Management System
import ADMSRoutes from "app/views/asset-disposal-system/create-requests/ADMSRoutes";

//Workflow
import WorkflowRoutes from "app/views/workflows/workflow-configuration/WorkflowRoutes";
import WorkflowStageRoutes from "app/views/workflows/workflow-stage-configuration/WorkflowStageRoutes";
import WorkflowAdminRoutes from "app/views/workflows/workflow-stage-configuration/WorkflowAdminRoutes";
import WhatsAppWalletRoutes from "app/views/admin-portal/whatsapp-wallet/WhatsAppWalletRoutes";
import WhatsAppCampaignRoutes from "app/views/admin-portal/whatsapp-campaigns/WhatsAppCampaignRoutes";
import WhatsAppInboxRoutes from "app/views/admin-portal/whatsapp-inbox/WhatsAppInboxRoutes";
import WhatsAppMessagePricingRoutes from "app/views/admin-portal/whatsapp-message-pricing/WhatsAppMessagePricingRoutes";
import WhatsAppTemplateReviewRoutes from "app/views/admin-portal/whatsapp-templates/WhatsAppTemplateReviewRoutes";
import WhatsAppOnboardingRoutes from "app/views/admin-portal/whatsapp-onboarding/WhatsAppOnboardingRoutes";
import MobileAppUpdateRoutes from "app/views/admin-portal/mobile-app-update/MobileAppUpdateRoutes";
import SaasAutopayOpsRoutes from "app/views/admin-portal/saas-autopay-ops/SaasAutopayOpsRoutes";
import SaasPlanAdminRoutes from "app/views/admin-portal/saas-plan-admin/SaasPlanAdminRoutes";

import VideoUploadRoutes from "app/views/video-streaming-portal/VideoUpload/VideoUploadRoutes";

// Public PAGES
import VerifyEmail from "app/views/public/VerifyEmail";

import RefundPolicy from "app/views/public/Refund-policy";
import TermsAndConditions from "app/views/public/Terms";
import ShippingPolicy from "app/views/public/Shipping-policy";
import PrivacyPolicy from "app/views/public/Privacy-policy";
import PublicTokenBookingPage from "app/views/healthcare-portal/public-token-booking/PublicTokenBookingPage";
import PublicHospitalRoot from "app/views/public/hospital-profile/PublicHospitalRoot";

//Billing Routes
import BillingRoutes from "app/views/billing-service/routes/BillingRoutes";
import PaymentGatewayRoutes from "app/views/billing-service/payment-gateway-config/PaymentGatewayRoutes";
import MasterBridgeRoutes from "app/views/master-bridge/MasterBridgeRoutes";

//Healthcare Portal
import PatientRoutes from "app/views/healthcare-portal/patient-registration-form/PatientRoutes";
import PatientTokenListRoutes from "app/views/healthcare-portal/patient-token/PatientTokenListRoutes";
import DoctorRoutes from "app/views/healthcare-portal/doctor-management/DoctorOnboardingRoutes";
import QueueBoardRoutes from "app/views/healthcare-portal/queue-board/QueueBoardRoutes";
import PatientVisitListRoutes from "app/views/healthcare-portal/patient-visits/PatientVisitsListRoutes";
import OPDRoutes from "app/views/healthcare-portal/OPDConsultation/OPDRoutes";
import PatientBillingRoutes from "app/views/healthcare-portal/patient-billing/PatientBillingRoutes";
import OperationalModuleRoutes, {
  OperationalAliasRoutes } from
"app/views/operational-module/OperationalModuleRoutes";
import LabCatalogRoutes from "app/views/lab-catalog/LabCatalogRoutes";
import RadiologyModuleRoutes from "app/views/radiology/RadiologyModuleRoutes";
import InpatientRoutes from "app/views/inpatient/InpatientRoutes";

// SESSION PAGES
const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
const NotAuthorized = Loadable(lazy(() => import("app/views/sessions/NotAuthorized")));
const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
const JwtRegister = Loadable(
  lazy(() => import("app/views/sessions/JwtRegister"))
);
const ForgotPassword = Loadable(
  lazy(() => import("app/views/sessions/ForgotPassword"))
);
// E-CHART PAGE
const AppEchart = Loadable(
  lazy(() => import("app/views/charts/echarts/AppEchart"))
);
// DASHBOARD PAGE
const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
const HospitalSetupWizardPage = Loadable(
  lazy(() => import("app/views/admin-portal/hospital-setup/HospitalSetupWizardPage"))
);
const Setup2FA = Loadable(lazy(() => import("app/views/sessions/Setup2FA")));
const Verify2FA = Loadable(
  lazy(() => import("app/views/sessions/TwoFactorPrompt"))
);

const routes = [
{
  element:
  <AuthGuard>
        <OnboardingGuard>
          <MatxLayout />
        </OnboardingGuard>
      </AuthGuard>,

  children: [
  ...materialRoutes,
  ...CoreRolesRoutes,
  ...MailConfigRoutes,
  ...MailServerConfigRoutes,
  ...MenuManagerRoutes,
  ...UserRolesRoutes,
  ...ManageUriRoutes,
  ...AccessControlRoutes,
  ...AuthConfigRoutes,
  ...UserProfileRoutes,
  ...OfficeLocationRoutes,
  ...OfficeLocationMappingRoutes,
  ...AccountRoutes,
  ...CrmRoutes,

  //Inventory-asset management
  ...CreateServersRoutes,
  ...CreateAssetRoutes,
  ...ManageAssetsDetailsRoutes,
  ...HardDiskRoutes,
  ...OsRoutes,
  ...RamRoutes,
  ...CategoryRoutes,
  ...ProcessorRoutes,
  ...GroupRoutes,
  ...SubGroupRoutes,
  ...AuditRoutes,
  ...VideoUploadRoutes,
  ...WarrentyCheckRoutes,
  ...VMRequestRoutes,
  ...DynamicTableRoutes,
  ...AssetTypeRoutes,

  //Employee management
  ...OnboardingRoutes,
  ...TimesheetRoutes,
  ...EmployeeAttendanceRoutes,
  ...LeaveTypeRoutes,
  ...LeaveApplicationRoutes,
  ...PublicHolidayRoutes,
  ...EmployeeAttendanceReportRoutes,
  ...DepartmentRoutes,

  //ITCMS
  ...ChangeRequestRoutes,

  //Asset Disposal Management System
  ...ADMSRoutes,

  //Workflow
  ...WorkflowRoutes,
  ...WorkflowStageRoutes,
  ...WorkflowAdminRoutes,
  ...WhatsAppWalletRoutes,
  ...SaasAutopayOpsRoutes,
  ...SaasPlanAdminRoutes,
  ...WhatsAppCampaignRoutes,
  ...WhatsAppInboxRoutes,
  ...WhatsAppMessagePricingRoutes,
  ...WhatsAppTemplateReviewRoutes,
  ...WhatsAppOnboardingRoutes,
  ...MobileAppUpdateRoutes,

  ...BillingRoutes,
  ...PaymentGatewayRoutes,
  ...MasterBridgeRoutes,
  ...InpatientRoutes,

  // Phase-1 operational runtime (OPS-PHASE1-008)
  ...OperationalAliasRoutes,
  ...OperationalModuleRoutes,
  ...LabCatalogRoutes,
  ...RadiologyModuleRoutes,

  // Healthcare Portal
  ...PatientRoutes,
  ...PatientTokenListRoutes,
  ...PatientVisitListRoutes,
  ...QueueBoardRoutes,
  ...DoctorRoutes,
  ...OPDRoutes,
  ...PatientBillingRoutes,
  // dashboard routes — canonical: /dashboard/default; /dashboard redirects for compatibility
  {
    path: "/dashboard",
    element: <Navigate to="/dashboard/default" replace />
  },
  {
    path: "/dashboard/default",
    element: <Analytics />,
    auth: authRoles.admin
  },
  {
    path: "/setup/hospital",
    element: <HospitalSetupWizardPage />
  },
  // e-chart route
  {
    path: "/charts/echarts",
    element: <AppEchart />,
    auth: authRoles.editor
  }]

},

{ path: "/verify/email", element: <VerifyEmail /> },
{ path: "/users/password-change", element: <PasswordChange /> },
{ path: "/not-authorized", element: <NotAuthorized /> },

// session pages route
{ path: "/session/404", element: <NotFound /> },
{ path: "/session/signin", element: <JwtLogin /> },
{ path: "/session/signup", element: <JwtRegister /> },
{ path: "/session/forgot-password", element: <ForgotPassword /> },
{ path: "/session/setup-2fa", element: <Setup2FA /> },
{ path: "/session/verify-2fa", element: <Verify2FA /> },
{ path: "/legal/refund-policy", element: <RefundPolicy /> },
{ path: "/legal/terms-and-conditions", element: <TermsAndConditions /> },
{ path: "/legal/shipping-policy", element: <ShippingPolicy /> },
{ path: "/legal/privacy-policy", element: <PrivacyPolicy /> },
{ path: "/book-token", element: <PublicTokenBookingPage /> },

{ path: "/", element: <PublicHospitalRoot /> },
{ path: "*", element: <NotFound /> }];


export default routes;